module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fmtitle"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_c('span', {
    staticClass: "abb_hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("BAR")])]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Biblical Archaeology Review")])]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_c('span', {
    staticClass: "abb_hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("BASOR")])]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bulletin of the American Schools of Oriental Research")])]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_c('span', {
    staticClass: "abb_hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("DOP")])]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dumbarton Oaks Papers")])]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_c('span', {
    staticClass: "abb_hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ERH")])]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("English Historical Review")])]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_c('span', {
    staticClass: "abb_hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Eu. Jud.")])]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("European Judaism: A Journal for the New Europe")])]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_c('span', {
    staticClass: "abb_hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("HTR")])]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Harvard Theological Review")])]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_c('span', {
    staticClass: "abb_hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("IEJ")])]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Israel Exploration Journal")])]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_c('span', {
    staticClass: "abb_hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JQR")])]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jewish Quarterly Review")])]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_c('span', {
    staticClass: "abb_hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JRS")])]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Journal of Roman Studies")])]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_c('span', {
    staticClass: "abb_hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("NAPNF 2")])]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Nicene and Post-Nicene Fathers of the Church")]), _vm._v(", Series 2")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_c('span', {
    staticClass: "abb_hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("NEAEHL")])]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The New Encyclopedia of Archaeological Excavations in the Holy Land")]), _vm._v(", Ephraim Stern (ed.), 1993–2008, Jerusalem")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_c('span', {
    staticClass: "abb_hang"
  }, [_vm._v("NEArch")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Near Eastern Archaeology")])]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_c('span', {
    staticClass: "abb_hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("PEQ")])]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Palestine Exploration Quarterly")])]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_c('span', {
    staticClass: "abb_hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("SHA")])]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Scriptores Historiae Augustae")]), _vm._v(" (see Primary Sources)")]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_c('span', {
    staticClass: "abb_hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("SOAS")])]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bulletin of the School of Oriental and African Studies")])]), _vm._v(" "), _c('p', {
    staticClass: "abb"
  }, [_c('span', {
    staticClass: "abb_hang"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("WCJS")])]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A World Congress of Jewish Studies")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c1ff8fd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Abbreviations.vue
// module id = 72
// module chunks = 0